// Phone-input country scope: PL + the seven InPost International destinations
// you can ship to from Poland. Keep in sync with apps/api/src/util/phoneCountries.ts.

import { getCountryCallingCode } from 'libphonenumber-js/mobile';
import { SHIPPING_COUNTRIES } from './shippingCountries';

export const PHONE_COUNTRIES = [
  { iso: 'PL', dial: '+48', name: 'Polska' },
  { iso: 'IT', dial: '+39', name: 'Włochy' },
  { iso: 'FR', dial: '+33', name: 'Francja' },
  { iso: 'BE', dial: '+32', name: 'Belgia' },
  { iso: 'NL', dial: '+31', name: 'Holandia' },
  { iso: 'LU', dial: '+352', name: 'Luksemburg' },
  { iso: 'ES', dial: '+34', name: 'Hiszpania' },
  { iso: 'PT', dial: '+351', name: 'Portugalia' },
] as const;

export type PhoneIso = (typeof PHONE_COUNTRIES)[number]['iso'];

export type PhoneCountry = { iso: string; dial: string; name: string };

/**
 * Every country the shop will send a parcel to, for an order that is not going through InPost.
 * Restricting a foreign buyer to InPost's seven destinations would let them pick Germany as a
 * destination and then refuse their German number.
 */
export const WORLD_PHONE_COUNTRIES: readonly PhoneCountry[] = [
  { iso: 'PL', dial: '+48', name: 'Polska' },
  ...SHIPPING_COUNTRIES.map((c) => ({
    iso: c.iso,
    dial: `+${getCountryCallingCode(c.iso)}`,
    name: c.name,
  })),
];

export const PHONE_COUNTRY_ISOS: readonly PhoneIso[] = PHONE_COUNTRIES.map((c) => c.iso);

export function isPhoneIso(value: string): value is PhoneIso {
  return (PHONE_COUNTRY_ISOS as readonly string[]).includes(value);
}
